import { DateFilter } from '../../../components/inputs/DateFilter';
import { AutocompleteFilter } from '../../../components/inputs/AutocompleteFilter';
import { DatasetID, FilterConfig, FilterType } from '../../../models/filter.model';
import AutoCompleteTreeFilter from 'common/components/inputs/AutoCompleteTreeFilter';
import { PlanningDateFilter } from 'common/components/inputs/PlanningDateFilter';

export function FilterBase({
  type,
  label,
  property,
  datasetId,
  overrideParentFilter,
  requiredFilters,
  validationMessage,
  toolTip,
}: FilterConfig & DatasetID) {
  return (
    <>
      {type === FilterType.DATE && <DateFilter datasetId={datasetId} />}
      {type === FilterType.PLANNING_DATE && <PlanningDateFilter datasetId={datasetId} />}
      {type === FilterType.AUTOCOMPLETE_TREE && (
        <AutoCompleteTreeFilter
          label={label}
          property={property}
          datasetId={datasetId}
          requiredFilters={requiredFilters}
          validationMessage={validationMessage}
          toolTip={toolTip}
        />
      )}
      {type === FilterType.AUTOCOMPLETE && (
        <AutocompleteFilter
          property={property}
          options={[]}
          label={label}
          datasetId={datasetId}
          overrideParentFilter={overrideParentFilter}
          requiredFilters={requiredFilters}
          validationMessage={validationMessage}
        />
      )}
    </>
  );
}
